import { HttpInterceptorFn } from '@angular/common/http';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const access_token = localStorage.getItem('access_token');
  if (!access_token) return next(req);
  req = req.clone({
    setHeaders: {
      Authorization: `Bearer ${access_token}`,
    },
  });
  return next(req);
};
